// extracted by mini-css-extract-plugin
module.exports = {"categories":"categories-3IpYA","categories__item":"categories__item-3D3KZ"};